import { LoginPageTranslations } from "./types";

export const deTranslations: LoginPageTranslations = {
    title: "Nur Admin-Login",
    labels: {
        email: "E-Mail",
        password: "Passwort",
        loginButton: "Anmelden",
    },
    heading: "Anmelden",
    maintenanceClosed:
        "Die Website ist wegen geplanter Wartung geschlossen. Ihr Passwort ist nicht das Problem — bitte versuchen Sie es später erneut.",
    chooseRole: {
        title: "Rolle auswählen",
        subtitle:
            "Sie sind an mehreren Stellen Admin. Wählen Sie eine aus, um fortzufahren.",
    },
};
